module.exports = __webpack_public_path__ + "static/028-333238ec005376a5846b6740faadea6f.png";